import { render, staticRenderFns } from "./BoUser.vue?vue&type=template&id=12b2aa22&"
import script from "./BoUser.vue?vue&type=script&lang=js&"
export * from "./BoUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports